import { IVentaCorporativoNoc } from "@/erp/noc/shared/componente/SaveAgendamientoNoc";
import { CustomTabPanel } from "@/erp/sale";
import {
  a11yProps,
  EstadosAgendamientoEnumChoice,
  formatHour,
  gridSize,
  gridSizeMdLg12,
  gridSizeMdLg6,
  handleErrorForm,
  newRecordinarAgendaCorporativo,
  ROUTER_PATHS,
  useTabsFormOnly,
} from "@/shared";
import { usePutAgendaCorporativa } from "@/shared/actions/erp/agendamiento_corporativo";
import {
  CustomButtunsRejectConfirm,
  CustomTextFieldNoForm,
  FormTabsOnly,
  SingleIconButton,
  TabsFormBoxScene,
  TabTextLabel,
} from "@/shared/components/ui";
import { CacheKeyCalendarioENUM, ErrorMessagesForm } from "@/shared/interfaces";
import { IAgendaCorporativo } from "@/shared/interfaces/erp/agenda_corporativo";
import { useFlotasStore } from "@/store/erp";
import { yupResolver } from "@hookform/resolvers/yup";
import EventRepeatIcon from "@mui/icons-material/EventRepeat";
import { Grid, Tab, Typography } from "@mui/material";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import CalendarioAgendaNoc from "../calendario_agenda_noc/CalendarioAgendaNoc";

type FormReasignarCorporativo = {
  flota: string;
  fecha_instalacion: string;
  hora_instalacion: string;

  celular_2?: string;
  flota_nombre?: string;
};

export interface SaveReasignarInstlacionAgendaCorpProps {
  title: string;
  agendamiento: IAgendaCorporativo;
}

export default function SaveReasignarInstlacionAgendaCorp({
  title,
  agendamiento,
}: SaveReasignarInstlacionAgendaCorpProps) {
  const navigate = useNavigate();

  const [isVisibleCalendario, setIsVisibleCalendario] =
    useState<boolean>(false);
  ///* form --------------------
  const form = useForm<FormReasignarCorporativo>({
    resolver: yupResolver(newRecordinarAgendaCorporativo),
  });
  const [noForm, setNoForm] = useState<IVentaCorporativoNoc | null>(null);

  const { handleSubmit, reset } = form;

  const { handleMethodChange, valueTab } = useTabsFormOnly({
    initialTabValue: 1,
  });

  ///* Hooks

  const { getFlotas } = useFlotasStore();

  ///* handlers --------------------
  const onEditHorario = async () => {
    // if cancel edit, set flota to db value
    if (isVisibleCalendario) {
      form.reset({
        ...form.getValues(),
        flota: agendamiento?.flota! || "",
        hora_instalacion: agendamiento.hora_instalacion,
      });
    }

    if (!isVisibleCalendario) {
      getFlotas({
        es_corporativo: true,
        page_size: 100,
      });
    }
    setIsVisibleCalendario(!isVisibleCalendario);
  };

  ///*
  const { mutateAsync: mutateAsyncPutAgenda } = usePutAgendaCorporativa({
    navigate,
    returnUrl: ROUTER_PATHS.noc.agendamientoNocNav,
  });

  ///* use effect
  useEffect(() => {
    const {
      prospecto_corporativo_data,
      preventa_corporativa_data: preventa_coporativo_data,
      ...rest
    } = agendamiento;
    reset({
      fecha_instalacion: rest.fecha_instalacion,
      hora_instalacion: rest.hora_instalacion,
      flota: rest.flota,
      flota_nombre: rest.flota_data.nombre,
    });

    setNoForm({
      ...prospecto_corporativo_data,
      ...preventa_coporativo_data,
      ...rest,
    } as any);
    return () => {};
  }, [agendamiento]);

  const handleSendForm = async (form: FormReasignarCorporativo) => {
    const sendForm = {
      ...form,
      estado_agenda: EstadosAgendamientoEnumChoice.RECORDINADO,
      hora_instalacion: isVisibleCalendario
        ? dayjs(form.hora_instalacion).format("HH:mm:ss")
        : agendamiento.hora_instalacion!,
    };

    if (agendamiento && agendamiento?.id_agenda_corporativa) {
      await mutateAsyncPutAgenda({
        id: agendamiento.id_agenda_corporativa!,
        data: sendForm as any,
      });
      return;
    }
  };

  return (
    <TabsFormBoxScene
      titlePage={title}
      showBtns={false}
      content={
        <>
          {agendamiento?.preventa_corporativa_data?.tipo_plan ? (
            <Typography>
              Cliente{" "}
              <b>{agendamiento?.preventa_corporativa_data?.tipo_plan}</b>
            </Typography>
          ) : null}
          {agendamiento?.prospecto_corporativo_data?.condicion_venta ? (
            <Typography>
              Condición Venta:{" "}
              <b>{agendamiento?.prospecto_corporativo_data?.condicion_venta}</b>
            </Typography>
          ) : null}
        </>
      }
      // customBtns
      showCustomBtns={true}
      customBtns={
        <CustomButtunsRejectConfirm
          onCancel={() => navigate(ROUTER_PATHS.noc.agendamientoNocNav)}
          onConfirm={handleSubmit(handleSendForm, (err) => {
            console.log(err);

            handleErrorForm(err as ErrorMessagesForm);
          })}
          rejectTextBtn="Enviar a Gestión Ventas"
          showRejectBtn={false}
          onReject={() => {}}
          sxContainer={{
            pt: 9,
          }}
        />
      }
      // tabs
      tabs={
        <FormTabsOnly onChange={handleMethodChange} value={valueTab}>
          <Tab label="DATOS DE AGENDAMIENTO" value={1} {...a11yProps(1)} />
          {/* <Tab label="DATOS DE SERVICIO" value={2} {...a11yProps(2)} /> */}
        </FormTabsOnly>
      }
    >
      <CustomTabPanel index={1} value={valueTab}>
        <Grid container spacing={3}>
          {/*=====================INFORMACION GENERAL========================*/}
          <Grid item xs={12}>
            <TabTextLabel text="Información General" mt={0} pb={0} pl={0} />
          </Grid>

          <CustomTextFieldNoForm
            disabled={true}
            label={"Tipo de identificación"}
            defaultValue={noForm?.tipo_identificacion || ""}
            value={noForm?.tipo_identificacion || ""}
            size={gridSizeMdLg6}
          />
          <CustomTextFieldNoForm
            disabled={true}
            label={"No. Identificacion"}
            defaultValue={noForm?.identificacion || ""}
            value={noForm?.identificacion || ""}
            size={gridSizeMdLg6}
          />

          <CustomTextFieldNoForm
            disabled={true}
            label={"Razon social"}
            defaultValue={noForm?.razon_social || ""}
            value={noForm?.razon_social || ""}
            size={gridSizeMdLg12}
          />

          <CustomTextFieldNoForm
            disabled={true}
            label={"Actividad economica principal"}
            defaultValue={noForm?.actividad_economica_principal || ""}
            value={noForm?.actividad_economica_principal || ""}
            size={gridSizeMdLg12}
          />

          <CustomTextFieldNoForm
            disabled={true}
            label={"Tag"}
            defaultValue={agendamiento.contrato_data?.tag || ""}
            value={agendamiento.contrato_data?.tag || ""}
            size={gridSizeMdLg12}
          />

          {/*=====================INFORMACION VENTA========================*/}

          <Grid item xs={12}>
            <TabTextLabel text="Información Venta" mt={0} pb={0} pl={0} />
          </Grid>

          <CustomTextFieldNoForm
            disabled={true}
            label={"Asesor"}
            defaultValue={noForm?.user_create || ""}
            value={noForm?.user_create || ""}
            size={gridSizeMdLg6}
          />

          <CustomTextFieldNoForm
            disabled={true}
            label={"Aprueba"}
            defaultValue={noForm?.user_aprueba || ""}
            value={noForm?.user_aprueba || ""}
            size={gridSizeMdLg6}
          />

          {/*=====================UBICACION========================*/}
          <Grid item xs={12}>
            <TabTextLabel text="Ubicación" mt={0} pb={0} pl={0} />
          </Grid>

          <CustomTextFieldNoForm
            disabled={true}
            label={"Coordenada servicio"}
            defaultValue={noForm?.coordenada_servicio || ""}
            value={noForm?.coordenada_servicio || ""}
            size={gridSizeMdLg12}
          />

          <CustomTextFieldNoForm
            disabled={true}
            label={"País"}
            defaultValue={noForm?.pais || ""}
            value={noForm?.pais || ""}
            size={gridSizeMdLg6}
          />

          <CustomTextFieldNoForm
            disabled={true}
            label={"Provincia"}
            defaultValue={noForm?.provincia_data?.nombre || ""}
            value={noForm?.provincia_data?.nombre || ""}
            size={gridSizeMdLg6}
          />

          <CustomTextFieldNoForm
            disabled={true}
            label={"Ciudad"}
            defaultValue={noForm?.ciudad_data?.nombre || ""}
            value={noForm?.ciudad_data?.nombre || ""}
            size={gridSizeMdLg6}
          />

          <CustomTextFieldNoForm
            disabled={true}
            label={"Zona"}
            defaultValue={noForm?.zona_data?.nombre || ""}
            value={noForm?.zona_data?.nombre || ""}
            size={gridSizeMdLg6}
          />

          <CustomTextFieldNoForm
            disabled={true}
            label={"Sector"}
            defaultValue={noForm?.sector_data?.nombre || ""}
            value={noForm?.sector_data?.nombre || ""}
            size={gridSizeMdLg12}
          />

          {/*=====================ACTUALIZAR HORARIOS========================*/}

          <Grid item xs={12} container pb="24px">
            <Typography
              variant="h6"
              sx={{
                display: "flex",
                alignItems: "start",
                justifyContent: "start",
                fontSize: ".9rem",
                color: "#6c737fb0",
              }}
            >
              HORARIO PREAGENDADO
            </Typography>
            <span className="spacer" />

            <SingleIconButton
              startIcon={<EventRepeatIcon />}
              color={isVisibleCalendario ? "error" : "primary"}
              label={isVisibleCalendario ? "Cancelar edición" : "Editar fecha"}
              onClick={onEditHorario}
            />
          </Grid>

          {!isVisibleCalendario && (
            <>
              <CustomTextFieldNoForm
                label="Fecha de instalación"
                value={agendamiento?.fecha_instalacion || "N/A"}
                size={gridSizeMdLg6}
                disabled
              />
              <CustomTextFieldNoForm
                label="Hora de instalación"
                value={
                  agendamiento?.hora_instalacion
                    ? formatHour(agendamiento?.hora_instalacion)
                    : "N/A"
                }
                size={gridSizeMdLg6}
                disabled
              />
              <CustomTextFieldNoForm
                label="Flota"
                value={form.getValues().flota_nombre || "N/A"}
                size={gridSize}
                disabled
              />
            </>
          )}

          {isVisibleCalendario && (
            <CalendarioAgendaNoc
              cacheKey={CacheKeyCalendarioENUM.KEY_CACHE_COORP_AGENDAMIENTO_NOC}
              form={form}
            />
          )}
        </Grid>
      </CustomTabPanel>
    </TabsFormBoxScene>
  );
}
